// Activar/desactivar avisos push del navegador (recordatorios de convocatoria
// pendiente). Requiere el service worker propio en public/sw.js.
import apiFetch from "services/http";

export function pushSoportado() {
  return "serviceWorker" in navigator && "PushManager" in window;
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

async function registrarServiceWorker() {
  return navigator.serviceWorker.register("/sw.js");
}

export async function obtenerSuscripcionActual() {
  if (!pushSoportado()) return null;
  const registration = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!registration) return null;
  return registration.pushManager.getSubscription();
}

export async function activarAvisos() {
  if (!pushSoportado()) {
    throw new Error("Este navegador no admite notificaciones push.");
  }

  const permiso = await Notification.requestPermission();
  if (permiso !== "granted") {
    throw new Error("Permiso de notificaciones denegado.");
  }

  const registration = await registrarServiceWorker();
  await navigator.serviceWorker.ready;

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const { publicKey } = await apiFetch("/api/push/public-key");
    if (!publicKey) {
      throw new Error("El servidor no tiene configurada la clave de notificaciones.");
    }
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  const json = subscription.toJSON();
  await apiFetch("/api/push/suscribir", {
    method: "POST",
    body: { endpoint: json.endpoint, keys: json.keys },
  });

  return subscription;
}

export async function desactivarAvisos() {
  const subscription = await obtenerSuscripcionActual();
  if (!subscription) return;

  const endpoint = subscription.endpoint;
  await subscription.unsubscribe();
  await apiFetch("/api/push/desuscribir", { method: "POST", body: { endpoint } }).catch(() => {});
}
